import { render, staticRenderFns } from "./FirstRank.vue?vue&type=template&id=0c53768c&scoped=true"
import script from "./FirstRank.vue?vue&type=script&lang=js"
export * from "./FirstRank.vue?vue&type=script&lang=js"
import style0 from "./FirstRank.vue?vue&type=style&index=0&id=0c53768c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c53768c",
  null
  
)

export default component.exports